import { UserService } from '@/services/user-service'
import { HTTP } from '@/services/http'
import { traverse } from '@/modules/util/object'

export class Settings {
	static API_BASE_URL = undefined
	static INDEX_DB_NAME = 'cache'
	static INDEX_DB_VERSION = 2
	static CACHE_EXPIRY = 1000 * 60 * 60 * 24
	static APP_COLOR = '#546E7A'
	static INSPECTION_TYPES = []
	static LOCATIONS = []

	static async init() {
		try {
			const settings = JSON.parse(localStorage.getItem('SETTINGS'))
		
			if (settings) {
				Object.keys(Settings).forEach(k => {
					Settings[k] = settings[k] || Settings[k]
				})
			}
		} catch (e) {
			console.warn('Error retrieving SETTINGS from Local Storage:', e.message)
		}
	
		try {
			const config = await (await fetch('/config.json')).json()

			Object.keys(config).forEach(k => {
				if (Object.prototype.hasOwnProperty.call(Settings, k)) {
					Settings[k] = config[k]
				} else {
					console.warn(`Unknown config key: ${k}`)
				}
			})

			if (!UserService.hasAuth()) {
				return true
			}

			const http = new HTTP(Settings.API_BASE_URL)

			let res = await Promise.all([
				http.get('/inspectiontypes'),
				http.get('/locations')
			])

			if (!res[0].body?.status) {
				if (res[0].body?.errorType === 'AUTHENTICATION_FAILED') {
					UserService.logout()
					return true
				}

				throw new Error(JSON.stringify(res[0].body))
			}
			Settings.INSPECTION_TYPES = res[0].body.inspectiontypes

			if (!res[1].body?.status) {
				throw new Error(JSON.stringify(res[1].body))
			}
			Settings.LOCATIONS = res[1].body.locations
			
			localStorage.setItem('SETTINGS', JSON.stringify(Object.keys(Settings).reduce((acc, k) => {
				acc[k] = Settings[k]
				return acc
			}, {})))
		} catch (e) {
			console.error('Config load failed:', e.message)

			return (
				Settings.API_BASE_URL && 
				Settings.INSPECTION_TYPES && 
				Settings.INDEX_DB_NAME &&
				Settings.INDEX_DB_VERSION &&
				Settings.CACHE_EXPIRY &&
				Settings.APP_COLOR
			)
		}

		return true
	}

	static cacheProgress(vehicleId, inspectionId, data) {
		localStorage.setItem('IN_PROGRESS_VEHICLE', vehicleId)
		localStorage.setItem('IN_PROGRESS_INSPECTION', inspectionId)
		localStorage.setItem('IN_PROGRESS_DATA', JSON.stringify(data))
	}

	static getProgress() {
		const vehicleId = localStorage.getItem('IN_PROGRESS_VEHICLE')
		const inspectionId = localStorage.getItem('IN_PROGRESS_INSPECTION')
		const data = localStorage.getItem('IN_PROGRESS_DATA')

		if (!vehicleId || !inspectionId || !data) {
			return null
		}

		try {
			return {
				vehicleId,
				inspectionId,
				data: JSON.parse(localStorage.getItem('IN_PROGRESS_DATA'))
			}
		} catch (e) {
			console.warn('Failed to retrieve cached progress:', e.message)
			Settings.clearProgress()
			return null
		}
	}

	static clearProgress(clearCache=false) {
		if (clearCache) {
			try {
				const data = JSON.parse(localStorage.getItem('IN_PROGRESS_DATA'))
				traverse(data || {}, (key, value) => {
					if (!value?.uid) {
						return
					}

					HTTP.deleteCached(value.uid)
				})
			} catch (e) {
				console.warn('Parse error:', e.message)
			}
		}

		localStorage.removeItem('IN_PROGRESS_VEHICLE')
		localStorage.removeItem('IN_PROGRESS_INSPECTION')
		localStorage.removeItem('IN_PROGRESS_DATA')
	}
}